const required = v => !!v || "Requerido.";

const email = v =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    v
  ) || "E-mail inválido.";

const phone = v =>
  /\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}/.test(v) || "Telefone inválido.";

const cep = v => /[0-9]{5}-[0-9]{3}/.test(v) || "CEP inválido.";

export { required, email, phone, cep };
